export default __webpack_public_path__ + "static/media/ic_arrow_right.fb31c701.svg";